export default __webpack_public_path__ + "static/1202-4eea05beb3cdf92cc3d890c7c36269aa.gif";